export default {
  resetPassword: 'Resetear contraseña',
  ready: 'Las instrucciones fueron enviadas a tu correo electrónico'
}
